module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='" + (['list-item', 'js-project-row', "" + ($e($c((this.project.get("createFailed") ? "project-failed" : "loading-project"))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n  <div class='icon icon-file'></div>\n  <div class='status'>");
      if (this.project.get("createFailed")) {
        $o.push("    <h5>Import Failed</h5>\n    <div class='subtext'>");
        $o.push("      " + $e($c(this.project.get("title") || this.project.get("url").substring(0, 70))));
        $o.push("    </div>");
      } else {
        $o.push("    <div class='loading'>\n      <div class='loading-bar'></div>\n    </div>");
      }
      $o.push("  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/loading.js.hamlc
// module id = 1511
// module chunks = 18